// AI 功能入口门控：入口按钮/菜单常显，点击时实时校验 AI 状态并告知具体不可用原因
// 用于 AI 助手、秦丝智能导入、语音输入、AI 生成打印模板等所有 AI 功能入口

import { ElMessageBox } from 'element-plus'
import { getAiStatus, type AiStatus } from '@/api/ai'

export interface AiGateOptions {
  /** 功能名（提示弹窗标题用），如"AI 助手"、"秦丝智能导入"、"语音输入" */
  featureName?: string
  /** 是否要求语音识别（ASR）已配置 */
  needAsr?: boolean
}

// 返回 true=可用（调用方继续业务流程）；false=不可用（已弹窗说明原因，调用方直接 return）
export async function checkAiAvailable(opts: AiGateOptions = {}): Promise<boolean> {
  const feature = opts.featureName || 'AI 功能'
  const alert = (msg: string): false => {
    ElMessageBox.alert(msg, `${feature}暂不可用`, { type: 'warning', confirmButtonText: '知道了' })
    return false
  }

  let s: AiStatus
  try {
    s = await getAiStatus()
  } catch {
    return alert('查询 AI 状态失败，请检查网络连接后重试。')
  }

  if (!s.configured) {
    return alert('AI 助手尚未启用或未完成配置。请管理员前往 系统设置 → AI 助手设置 启用并选择模型后再试。')
  }
  if (!s.canUse) {
    return alert('当前账号没有 AI 使用权限。请联系管理员在 系统管理 → 角色管理 中分配"使用AI助手"权限后再试。')
  }
  if (!s.enabled && !s.free && Number(s.balance) <= 0) {
    return alert(`AI 账户余额不足（当前余额 ¥${Number(s.balance || 0).toFixed(4)}）。AI 调用按量计费，请管理员前往 AI 助手设置充值后再试。`)
  }
  if (!s.enabled) {
    return alert('AI 助手当前未启用，请联系管理员前往 系统设置 → AI 助手设置 开启后再试。')
  }
  if (opts.needAsr && !s.asr) {
    return alert('语音输入未配置。请管理员前往 系统设置 → AI 助手设置 配置语音识别密钥后再试；您仍可继续使用文字输入。')
  }
  return true
}
